import { CustomIconDefinition } from '../types';

export const nepDropdown: CustomIconDefinition = {
  prefix: 'nep',
  iconName: 'dropdown',
  icon: [750, 750, [], 'e104', 'M0 355L375 745 750 355H0Z'],
};
